import React from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import { WebStorageStateStore } from "oidc-client-ts";
import App, { AuthedApp } from "./App";
import "./index.css";

// Cognito OIDC. authority = the user-pool issuer; oidc-client-ts discovers the
// hosted-UI authorize endpoint from its .well-known doc. The ID token is sent
// to the API as a Bearer header.
const oidcConfig = {
  authority: process.env.REACT_APP_COGNITO_AUTHORITY,
  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID,
  // No trailing slash: must match the Cognito callback URL exactly.
  redirect_uri: window.location.origin,
  response_type: "code",
  scope: "openid email profile",
  // Persist the session in localStorage (not the default sessionStorage, which
  // is wiped when the tab/window closes), so the user stays signed in across
  // tab and browser restarts (jobuna#68).
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  // Transparently refresh the short-lived ID/access token via the refresh token
  // before it expires, so the user is only sent back to login when the refresh
  // token itself is revoked or expired (jobuna#68).
  automaticSilentRenew: true,
  // Clean ?code=&state= out of the URL after the redirect callback.
  onSigninCallback: () => window.history.replaceState({}, document.title, window.location.pathname),
};

const configured = Boolean(oidcConfig.authority && oidcConfig.client_id);

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    {configured ? (
      <AuthProvider {...oidcConfig}>
        <AuthedApp />
      </AuthProvider>
    ) : (
      <App />
    )}
  </React.StrictMode>,
);
